import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import './ClientInviteModal.css';
import MessageModal from 'components/shared/modal/MessageModal';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import {
  setShowInviteClientModal,
  submitFormRequest,
  inviteClient,
  inviteExistentClient,
  updateFormValue,
} from 'actions/admin/clients/clients';
import FormModal from 'components/shared/modal/FormModal';
import {
  getForm,
  getInvalidFields,
  getShowInviteClientModal,
  getValidationMessage,
} from 'selectors/admin/clients/clients';
import Input from 'components/shared/input/Input';
import RadioButton from 'components/shared/radio-button/RadioButton';

class ClientInviteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmationMessage: false,
      confirmSimilarClient: null,
    };
  }

  handleClose = () => {
    this.props.dispatch(setShowInviteClientModal(false));
  };

  handleCreateClient = (existentClientId) => {
    if (existentClientId) {
      this.props.dispatch(inviteExistentClient(existentClientId));
    } else {
      this.props.dispatch(inviteClient(this.props.form)).then((response) => {
        if (response.ok) {
          this.setState({
            showConfirmationMessage: true,
          });
        }
      });
    }
  };

  handleSimilarClient = (client, similarMsg) => {
    const message = `${similarMsg} Do you want to use it?`;
    this.setState({
      confirmSimilarClient: { clientId: client.id, message: message },
    });
  };

  similarClientConfirmed = (confirmed) => {
    const clientId = this.state.confirmSimilarClient.clientId;
    this.setState({ confirmSimilarClient: null });
    this.handleCreateClient(confirmed ? clientId : null);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const promise = this.props.dispatch(submitFormRequest(this.props.form));
    if (promise !== null) {
      promise.then((response) => {
        if (response.ok) {
          if (response.client) {
            this.handleSimilarClient(response.client, response.message);
          } else {
            this.handleCreateClient();
          }
        }
      });
    }
  };

  handleAttributeChange = (attribute, value) => {
    this.props.dispatch(updateFormValue(attribute, value));
  };

  handleCloseConfirmationModal = () => {
    this.setState({
      showConfirmationMessage: false,
    });
  };

  isFieldValid(fieldName) {
    return (
      this.props.invalidFields.find((element) => element === fieldName) ===
      undefined
    );
  }

  render() {
    const { showConfirmationMessage, confirmSimilarClient } = this.state;

    return (
      <div id="invite-client-form-modal">
        <FormModal
          className="invite-client-modal"
          show={this.props.showInviteClientModal}
          title={'Invite Client'}
          onClose={this.handleClose}
        >
          <Form horizontal onSubmit={this.handleSubmit}>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Company Name
              </Col>
              <Col sm={8}>
                <Input
                  id="company-name"
                  placeholder="Company Name"
                  valid={this.isFieldValid('companyName')}
                  value={this.props.form.companyName}
                  theme="normal"
                  onChange={this.handleAttributeChange.bind(
                    this,
                    'companyName'
                  )}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                First Name
              </Col>
              <Col sm={8}>
                <Input
                  id="first-name"
                  placeholder="First Name"
                  valid={this.isFieldValid('firstName')}
                  value={this.props.form.firstName}
                  theme="normal"
                  onChange={this.handleAttributeChange.bind(this, 'firstName')}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Last Name
              </Col>
              <Col sm={8}>
                <Input
                  id="last-name"
                  placeholder="Last Name"
                  theme="normal"
                  valid={this.isFieldValid('lastName')}
                  value={this.props.form.lastName}
                  onChange={this.handleAttributeChange.bind(this, 'lastName')}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Email
              </Col>
              <Col sm={8}>
                <Input
                  id="email"
                  placeholder="Email"
                  theme="normal"
                  type="email"
                  valid={this.isFieldValid('email')}
                  value={this.props.form.email}
                  onChange={this.handleAttributeChange.bind(this, 'email')}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Phone Number
              </Col>
              <Col sm={8}>
                <Input
                  id="phone-number"
                  placeholder="Phone Number"
                  theme="normal"
                  valid={this.isFieldValid('phoneNumber')}
                  value={this.props.form.phoneNumber}
                  onChange={this.handleAttributeChange.bind(
                    this,
                    'phoneNumber'
                  )}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Street Address 1
              </Col>
              <Col sm={8}>
                <Input
                  id="street-address-1"
                  placeholder="Street Address 1"
                  theme="normal"
                  valid={this.isFieldValid('streetAddress1')}
                  value={this.props.form.streetAddress1}
                  onChange={this.handleAttributeChange.bind(
                    this,
                    'streetAddress1'
                  )}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Street Address 2
              </Col>
              <Col sm={8}>
                <Input
                  placeholder="Street Address 2"
                  theme="normal"
                  valid={this.isFieldValid('streetAddress2')}
                  value={this.props.form.streetAddress2}
                  onChange={this.handleAttributeChange.bind(
                    this,
                    'streetAddress2'
                  )}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                City / State
              </Col>
              <Col sm={5}>
                <Input
                  id="city"
                  placeholder="City"
                  theme="normal"
                  valid={this.isFieldValid('city')}
                  value={this.props.form.city}
                  onChange={this.handleAttributeChange.bind(this, 'city')}
                />
              </Col>
              <Col sm={3}>
                <Input
                  id="state"
                  placeholder="State"
                  theme="normal"
                  valid={this.isFieldValid('state')}
                  value={this.props.form.state}
                  onChange={this.handleAttributeChange.bind(this, 'state')}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Zip
              </Col>
              <Col sm={8}>
                <Input
                  id="zip"
                  placeholder="Zip"
                  theme="normal"
                  valid={this.isFieldValid('zip')}
                  value={this.props.form.zip}
                  onChange={this.handleAttributeChange.bind(this, 'zip')}
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                Global PO with running balance?
              </Col>
              <Col sm={8}>
                <RadioButton
                  options={[
                    {
                      value: 1,
                      label: 'Yes',
                    },
                    {
                      value: 0,
                      label: 'No',
                    },
                  ]}
                  value={
                    this.props.form.globalPurchaseOrderRequired !== null
                      ? this.props.form.globalPurchaseOrderRequired
                        ? 1
                        : 0
                      : null
                  }
                  onChange={(value) =>
                    this.handleAttributeChange(
                      'globalPurchaseOrderRequired',
                      value === 1
                    )
                  }
                />
              </Col>
            </FormGroup>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>
                PO for each work order?
              </Col>
              <Col sm={8}>
                <RadioButton
                  options={[
                    {
                      value: 1,
                      label: 'Yes',
                    },
                    {
                      value: 0,
                      label: 'No',
                    },
                  ]}
                  value={
                    this.props.form.purchaseOrderRequired !== null
                      ? this.props.form.purchaseOrderRequired
                        ? 1
                        : 0
                      : null
                  }
                  onChange={(value) =>
                    this.handleAttributeChange(
                      'purchaseOrderRequired',
                      value === 1
                    )
                  }
                />
              </Col>
            </FormGroup>

            {this.props.validationMessage !== '' && (
              <div className="invalid-message">
                {this.props.validationMessage}
              </div>
            )}

            <FormGroup className="button-container">
              <Col sm={12}>
                <input
                  id="send-invite"
                  className="btn button button-orange"
                  value={'Send Invite'}
                  type="submit"
                />
              </Col>
            </FormGroup>
          </Form>
        </FormModal>
        {confirmSimilarClient && (
          <ConfirmationModal
            show={confirmSimilarClient ? true : false}
            message={confirmSimilarClient.message}
            onHide={this.similarClientConfirmed}
          />
        )}

        <MessageModal
          show={showConfirmationMessage}
          message={
            <div>
              An invite has been sent to <b>{this.props.form.email}</b> to join
              Spackle as Client.
            </div>
          }
          onHide={this.handleCloseConfirmationModal}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    form: getForm(state),
    invalidFields: getInvalidFields(state),
    showInviteClientModal: getShowInviteClientModal(state),
    validationMessage: getValidationMessage(state),
  };
})(ClientInviteModal);



// WEBPACK FOOTER //
// ./src/components/admin/clients/ClientInviteModal.js